module.exports = __webpack_public_path__ + "static/fv-board-mobile-2c7df8b246a63481cd5c43523d379eec.jpg";